export const edgeDevicesActionTypes = {
  // Fetch edge device clusters
  FETCH_CLUSTERS_START: "FETCH_CLUSTERS_START",
  FETCH_CLUSTERS_SUCCESS: "FETCH_CLUSTERS_SUCCESS",
  FETCH_CLUSTERS_FAILURE: "FETCH_CLUSTERS_FAILURE",
  
  // Create cluster
  CREATE_CLUSTER_START: "CREATE_CLUSTER_START",
  CREATE_CLUSTER_SUCCESS: "CREATE_CLUSTER_SUCCESS",
  CREATE_CLUSTER_FAILURE: "CREATE_CLUSTER_FAILURE",
  
  // Delete cluster
  DELETE_CLUSTER_START: "DELETE_CLUSTER_START",
  DELETE_CLUSTER_SUCCESS: "DELETE_CLUSTER_SUCCESS",
  DELETE_CLUSTER_FAILURE: "DELETE_CLUSTER_FAILURE",
  
  // Update cluster status (start/stop)
  UPDATE_CLUSTER_STATUS_START: "UPDATE_CLUSTER_STATUS_START",
  UPDATE_CLUSTER_STATUS_SUCCESS: "UPDATE_CLUSTER_STATUS_SUCCESS",
  UPDATE_CLUSTER_STATUS_FAILURE: "UPDATE_CLUSTER_STATUS_FAILURE",
  
  // Get cluster details
  FETCH_CLUSTER_DETAILS_START: "FETCH_CLUSTER_DETAILS_START",
  FETCH_CLUSTER_DETAILS_SUCCESS: "FETCH_CLUSTER_DETAILS_SUCCESS",
  FETCH_CLUSTER_DETAILS_FAILURE: "FETCH_CLUSTER_DETAILS_FAILURE",
  
  // Get cluster health
  FETCH_CLUSTER_HEALTH_START: "FETCH_CLUSTER_HEALTH_START",
  FETCH_CLUSTER_HEALTH_SUCCESS: "FETCH_CLUSTER_HEALTH_SUCCESS",
  FETCH_CLUSTER_HEALTH_FAILURE: "FETCH_CLUSTER_HEALTH_FAILURE",
  
  // Get service status
  FETCH_SERVICE_STATUS_START: "FETCH_SERVICE_STATUS_START",
  FETCH_SERVICE_STATUS_SUCCESS: "FETCH_SERVICE_STATUS_SUCCESS",
  FETCH_SERVICE_STATUS_FAILURE: "FETCH_SERVICE_STATUS_FAILURE",
  
  // Install application in cluster
  INSTALL_APP_START: "INSTALL_APP_START",
  INSTALL_APP_SUCCESS: "INSTALL_APP_SUCCESS",
  INSTALL_APP_FAILURE: "INSTALL_APP_FAILURE",
  
  // Fetch applications
  FETCH_APPS_START: "FETCH_APPS_START",
  FETCH_APPS_SUCCESS: "FETCH_APPS_SUCCESS",
  FETCH_APPS_FAILURE: "FETCH_APPS_FAILURE",
  
  // Get application details
  FETCH_APP_DETAILS_START: "FETCH_APP_DETAILS_START",
  FETCH_APP_DETAILS_SUCCESS: "FETCH_APP_DETAILS_SUCCESS",
  FETCH_APP_DETAILS_FAILURE: "FETCH_APP_DETAILS_FAILURE",
  
  // Update application status
  UPDATE_APP_STATUS_START: "UPDATE_APP_STATUS_START",
  UPDATE_APP_STATUS_SUCCESS: "UPDATE_APP_STATUS_SUCCESS",
  UPDATE_APP_STATUS_FAILURE: "UPDATE_APP_STATUS_FAILURE",
  
  // Delete application
  DELETE_APP_START: "DELETE_APP_START",
  DELETE_APP_SUCCESS: "DELETE_APP_SUCCESS",
  DELETE_APP_FAILURE: "DELETE_APP_FAILURE",
  
  // Scale application
  SCALE_APP_START: "SCALE_APP_START",
  SCALE_APP_SUCCESS: "SCALE_APP_SUCCESS",
  SCALE_APP_FAILURE: "SCALE_APP_FAILURE",
  
  // Restart application
  RESTART_APP_START: "RESTART_APP_START",
  RESTART_APP_SUCCESS: "RESTART_APP_SUCCESS",
  RESTART_APP_FAILURE: "RESTART_APP_FAILURE",
  
  // Fetch nodes
  FETCH_NODES_START: "FETCH_NODES_START",
  FETCH_NODES_SUCCESS: "FETCH_NODES_SUCCESS",
  FETCH_NODES_FAILURE: "FETCH_NODES_FAILURE",
  
  // Create node manually
  CREATE_NODE_START: "CREATE_NODE_START",
  CREATE_NODE_SUCCESS: "CREATE_NODE_SUCCESS",
  CREATE_NODE_FAILURE: "CREATE_NODE_FAILURE",
  
  // Get node telemetry
  FETCH_NODE_TELEMETRY_START: "FETCH_NODE_TELEMETRY_START",
  FETCH_NODE_TELEMETRY_SUCCESS: "FETCH_NODE_TELEMETRY_SUCCESS",
  FETCH_NODE_TELEMETRY_FAILURE: "FETCH_NODE_TELEMETRY_FAILURE",
  
  // Update node status
  UPDATE_NODE_STATUS_START: "UPDATE_NODE_STATUS_START",
  UPDATE_NODE_STATUS_SUCCESS: "UPDATE_NODE_STATUS_SUCCESS",
  UPDATE_NODE_STATUS_FAILURE: "UPDATE_NODE_STATUS_FAILURE",
  
  // Delete node
  DELETE_NODE_START: "DELETE_NODE_START",
  DELETE_NODE_SUCCESS: "DELETE_NODE_SUCCESS",
  DELETE_NODE_FAILURE: "DELETE_NODE_FAILURE",
  
  // Fetch services
  FETCH_SERVICES_START: "FETCH_SERVICES_START",
  FETCH_SERVICES_SUCCESS: "FETCH_SERVICES_SUCCESS",
  FETCH_SERVICES_FAILURE: "FETCH_SERVICES_FAILURE",
  
  // Fetch pods
  FETCH_PODS_START: "FETCH_PODS_START",
  FETCH_PODS_SUCCESS: "FETCH_PODS_SUCCESS",
  FETCH_PODS_FAILURE: "FETCH_PODS_FAILURE",
  
  // Terminal command operations
  EXECUTE_TERMINAL_COMMAND_START: "EXECUTE_TERMINAL_COMMAND_START",
  EXECUTE_TERMINAL_COMMAND_SUCCESS: "EXECUTE_TERMINAL_COMMAND_SUCCESS",
  EXECUTE_TERMINAL_COMMAND_FAILURE: "EXECUTE_TERMINAL_COMMAND_FAILURE",
  
  // Set active cluster (for UI state)
  SET_ACTIVE_CLUSTER: "SET_ACTIVE_CLUSTER",
  SET_ACTIVE_NAMESPACE: "SET_ACTIVE_NAMESPACE",
  
  // Terminal connection
  CONNECT_TERMINAL_START: "CONNECT_TERMINAL_START",
  CONNECT_TERMINAL_SUCCESS: "CONNECT_TERMINAL_SUCCESS",
  CONNECT_TERMINAL_FAILURE: "CONNECT_TERMINAL_FAILURE",
  DISCONNECT_TERMINAL: "DISCONNECT_TERMINAL",
  
  // Clear terminal
  CLEAR_TERMINAL_OUTPUT: "CLEAR_TERMINAL_OUTPUT",
  ADD_TERMINAL_OUTPUT: "ADD_TERMINAL_OUTPUT",
  
  // RBAC - Users
  FETCH_RBAC_USERS_START: "FETCH_RBAC_USERS_START",
  FETCH_RBAC_USERS_SUCCESS: "FETCH_RBAC_USERS_SUCCESS",
  FETCH_RBAC_USERS_FAILURE: "FETCH_RBAC_USERS_FAILURE",
  
  // RBAC - Invite User
  INVITE_USER_START: "INVITE_USER_START",
  INVITE_USER_SUCCESS: "INVITE_USER_SUCCESS",
  INVITE_USER_FAILURE: "INVITE_USER_FAILURE",
  
  // RBAC - Update User Role
  UPDATE_USER_ROLE_START: "UPDATE_USER_ROLE_START", 
  UPDATE_USER_ROLE_SUCCESS: "UPDATE_USER_ROLE_SUCCESS",
  UPDATE_USER_ROLE_FAILURE: "UPDATE_USER_ROLE_FAILURE",
  
  // RBAC - Delete User
  DELETE_USER_START: "DELETE_USER_START",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  DELETE_USER_FAILURE: "DELETE_USER_FAILURE",
  
  // RBAC - Fetch Roles
  FETCH_ROLES_START: "FETCH_ROLES_START",
  FETCH_ROLES_SUCCESS: "FETCH_ROLES_SUCCESS",
  FETCH_ROLES_FAILURE: "FETCH_ROLES_FAILURE",

  // Node assignment actions
  ASSIGN_NODE_START: "ASSIGN_NODE_START",
  ASSIGN_NODE_SUCCESS: "ASSIGN_NODE_SUCCESS",
  ASSIGN_NODE_FAILURE: "ASSIGN_NODE_FAILURE",

  // Node removal actions
  REMOVE_NODE_START: "REMOVE_NODE_START",
  REMOVE_NODE_SUCCESS: "REMOVE_NODE_SUCCESS",
  REMOVE_NODE_FAILURE: "REMOVE_NODE_FAILURE",

  // Node transfer actions
  TRANSFER_NODE_START: "TRANSFER_NODE_START",
  TRANSFER_NODE_SUCCESS: "TRANSFER_NODE_SUCCESS",
  TRANSFER_NODE_FAILURE: "TRANSFER_NODE_FAILURE",

  // Fetch unassigned nodes
  FETCH_UNASSIGNED_NODES_START: "FETCH_UNASSIGNED_NODES_START",
  FETCH_UNASSIGNED_NODES_SUCCESS: "FETCH_UNASSIGNED_NODES_SUCCESS",
  FETCH_UNASSIGNED_NODES_FAILURE: "FETCH_UNASSIGNED_NODES_FAILURE",

  // Device registration management (admin only)
  FETCH_PENDING_DEVICES_START: "FETCH_PENDING_DEVICES_START",
  FETCH_PENDING_DEVICES_SUCCESS: "FETCH_PENDING_DEVICES_SUCCESS",
  FETCH_PENDING_DEVICES_FAILURE: "FETCH_PENDING_DEVICES_FAILURE",

  // Approve device registration
  APPROVE_DEVICE_START: "APPROVE_DEVICE_START",
  APPROVE_DEVICE_SUCCESS: "APPROVE_DEVICE_SUCCESS",
  APPROVE_DEVICE_FAILURE: "APPROVE_DEVICE_FAILURE",

  // Reject device registration
  REJECT_DEVICE_START: "REJECT_DEVICE_START",
  REJECT_DEVICE_SUCCESS: "REJECT_DEVICE_SUCCESS",
  REJECT_DEVICE_FAILURE: "REJECT_DEVICE_FAILURE"
}; 